import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18.999 22H4.99902C3.89445 22 2.99902 21.1046 2.99902 20V6C2.99902 4.89543 3.89445 4 4.99902 4H6.99902V2H8.99902V4H14.999V2H16.999V4H18.999C20.1036 4 20.999 4.89543 20.999 6V20C20.999 21.1046 20.1036 22 18.999 22ZM4.99902 10V20H18.999V10H4.99902ZM4.99902 6V8H18.999V6H4.99902Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CalendarCalendar"
);
